(() => {
  if (window.CTHeaderV113) return;
  window.CTHeaderV113 = true;

  const menuDrawer = document.querySelector('[data-ct-menu-drawer]');
  const menuOverlay = document.querySelector('[data-ct-menu-overlay]');
  const menuOpenButton = document.querySelector('[data-ct-menu-open]');
  const menuCloseButton = document.querySelector('[data-ct-menu-close]');

  const cartDrawer = document.querySelector('[data-ct-cart-drawer]');
  const cartOverlay = document.querySelector('[data-ct-cart-overlay]');
  const cartOpenButton = document.querySelector('[data-ct-cart-open]');
  const cartCloseButton = document.querySelector('[data-ct-cart-close]');
  const cartContinueButton = document.querySelector('[data-ct-cart-continue]');
  const cartBody = document.querySelector('[data-ct-cart-body]');
  const cartFooter = document.querySelector('[data-ct-cart-footer]');
  const cartSubtotal = document.querySelector('[data-ct-cart-subtotal]');
  const cartCompareTotal = document.querySelector('[data-ct-cart-compare-total]');
  const cartCompareRow = document.querySelector('[data-ct-cart-compare-row]');
  const cartSavingsRow = document.querySelector('[data-ct-cart-savings-row]');
  const cartSavings = document.querySelector('[data-ct-cart-savings]');

  const cartText = {
    currency: cartDrawer?.dataset.ctCurrency || 'TRY',
    loadingText: cartDrawer?.dataset.ctLoadingText || '',
    emptyTitle: cartDrawer?.dataset.ctEmptyTitle || '',
    emptyText: cartDrawer?.dataset.ctEmptyText || '',
    errorTitle: cartDrawer?.dataset.ctErrorTitle || '',
    errorText: cartDrawer?.dataset.ctErrorText || '',
    quantityLabel: cartDrawer?.dataset.ctQuantityLabel || '',
    qtyDecreaseLabel: cartDrawer?.dataset.ctQtyDecreaseLabel || '',
    qtyIncreaseLabel: cartDrawer?.dataset.ctQtyIncreaseLabel || '',
    removeText: cartDrawer?.dataset.ctRemoveText || ''
  };

  if (!menuDrawer || !menuOverlay || !menuOpenButton || !menuCloseButton) return;

  let previousFocus = null;
  let cartRequestController = null;
  const variantCompareCache = new Map();

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(focusableSelector))
      .filter((element) => element.offsetParent !== null);
  }

  function getPanelDuration(element, fallback = 500) {
    if (!element) return fallback;

    const raw = window.getComputedStyle(element).getPropertyValue('--ct-menu-duration');
    const parsed = Number.parseFloat(raw);

    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function lockBody() {
    document.body.classList.add('ct-menu-is-open');
  }

  function unlockBody() {
    if (!menuDrawer.classList.contains('is-open') && (!cartDrawer || !cartDrawer.classList.contains('is-open'))) {
      document.body.classList.remove('ct-menu-is-open');
    }
  }

  function openMenu() {
    previousFocus = document.activeElement;

    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();

    menuDrawer.classList.add('is-rendering');
    menuDrawer.setAttribute('aria-hidden', 'false');

    menuOverlay.hidden = false;

    requestAnimationFrame(() => {
      menuOverlay.classList.add('is-visible');
      menuDrawer.classList.add('is-open');

      window.setTimeout(() => {
        menuDrawer.classList.remove('is-rendering');
      }, getPanelDuration(menuDrawer, 500));
    });

    lockBody();
    menuOpenButton.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => {
      const focusable = getFocusableElements(menuDrawer);
      if (focusable.length) focusable[0].focus();
    });
  }

  function closeMenu() {
    const duration = getPanelDuration(menuDrawer, 500);

    menuDrawer.classList.add('is-rendering');
    menuOverlay.classList.remove('is-visible');
    menuDrawer.classList.remove('is-open');
    menuDrawer.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
      if (!menuDrawer.classList.contains('is-open')) {
        menuOverlay.hidden = true;
        menuDrawer.classList.remove('is-rendering');
      }
    }, duration);

    menuOpenButton.setAttribute('aria-expanded', 'false');
    unlockBody();

    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: cartText.currency || 'TRY',
        minimumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return value.toFixed(2).replace('.', ',') + ' TL';
    }
  }

  function getLineCompareAtPrice(item) {
    if (item && item._ct_compare_at_price) {
      const injected = Number(item._ct_compare_at_price);
      if (!Number.isNaN(injected) && injected > 0) return injected;
    }

    const properties = item && item.properties ? item.properties : {};
    const raw =
      properties._ct_compare_at_price ||
      properties.ct_compare_at_price ||
      properties.compare_at_price ||
      null;

    const parsed = Number(raw);

    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }

    return 0;
  }

  function productHandleFromItem(item) {
    if (item && item.handle) return item.handle;

    const url = item && item.url ? String(item.url) : '';
    const match = url.match(/\/products\/([^?/#]+)/);

    return match ? match[1] : '';
  }

  async function getVariantCompareAtFromProduct(item) {
    const variantId = item && item.variant_id ? String(item.variant_id) : '';
    const handle = productHandleFromItem(item);

    if (!variantId || !handle) return 0;

    const cacheKey = `${handle}:${variantId}`;

    if (variantCompareCache.has(cacheKey)) {
      return variantCompareCache.get(cacheKey);
    }

    try {
      const response = await fetch(`/products/${handle}.js`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'force-cache'
      });

      if (!response.ok) {
        variantCompareCache.set(cacheKey, 0);
        return 0;
      }

      const product = await response.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variant = variants.find((entry) => String(entry.id) === variantId);

      if (!variant) {
        variantCompareCache.set(cacheKey, 0);
        return 0;
      }

      const compareAt = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || item.final_price || 0);
      const validCompareAt = compareAt > price ? compareAt : 0;

      variantCompareCache.set(cacheKey, validCompareAt);
      return validCompareAt;
    } catch (error) {
      variantCompareCache.set(cacheKey, 0);
      return 0;
    }
  }

  async function hydrateCartCompareAt(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return cart;

    await Promise.all(cart.items.map(async (item) => {
      if (getLineCompareAtPrice(item) > 0) return;

      const compareAt = await getVariantCompareAtFromProduct(item);

      if (compareAt > 0) {
        item._ct_compare_at_price = compareAt;
      }
    }));

    return cart;
  }

  function escapeHTML(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function updateHeaderCartCount(count) {
    const normalized = Math.max(0, Number(count || 0));

    document.querySelectorAll('[data-ct-header-cart-count], .ct-header__cart-count').forEach((element) => {
      element.textContent = String(normalized);
      element.hidden = normalized <= 0;
      element.classList.toggle('is-empty', normalized <= 0);
    });
  }

  async function renderCart(cart) {
    if (!cartBody || !cartFooter || !cartSubtotal) return;

    updateHeaderCartCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);

    if (cart && Array.isArray(cart.items) && cart.items.length > 0) {
      await hydrateCartCompareAt(cart);
    }

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      cartBody.innerHTML = `<div class="ct-cart-drawer__empty"><div><strong>${escapeHTML(cartText.emptyTitle)}</strong><span>${escapeHTML(cartText.emptyText)}</span></div></div>`;
      cartSubtotal.textContent = formatMoney(0);

      if (cartCompareTotal) {
        cartCompareTotal.textContent = '';
        cartCompareTotal.hidden = true;
      }
      if (cartCompareRow) {
        cartCompareRow.hidden = true;
        cartCompareRow.style.display = 'none';
      }

      if (cartSavings) cartSavings.textContent = '';
      if (cartSavingsRow) {
        cartSavingsRow.hidden = true;
        cartSavingsRow.style.display = 'none';
      }

      cartFooter.hidden = true;
      return;
    }

    let compareTotal = 0;
    let totalPrice = Number(cart.total_price || 0);

    cartBody.innerHTML = `
      <div class="ct-cart-drawer__items">
        ${cart.items.map((item) => {
          const currentLine = Number(item.final_line_price || 0);
          const compareAtUnit = getLineCompareAtPrice(item);
          const compareLineFromProperty = compareAtUnit > 0 ? compareAtUnit * Number(item.quantity || 1) : 0;
          const originalLine = Number(item.original_line_price || currentLine);
          const compareLine = Math.max(compareLineFromProperty, originalLine, currentLine);
          const hasLineDiscount = compareLine > currentLine;

          compareTotal += hasLineDiscount ? compareLine : currentLine;

          return `
            <article class="ct-cart-item" data-ct-cart-item-key="${escapeHTML(item.key)}">
              <a class="ct-cart-item__image" href="${escapeHTML(item.url)}">
                ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : ''}
              </a>

              <div class="ct-cart-item__content">
                <a class="ct-cart-item__title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="ct-cart-item__variant">${escapeHTML(item.variant_title)}</div>` : ''}

                <div class="ct-cart-item__bottom">
                  <div class="ct-cart-item__qty" aria-label="${escapeHTML(cartText.quantityLabel)}">
                    <button type="button" data-ct-cart-qty="${item.quantity - 1}" aria-label="${escapeHTML(cartText.qtyDecreaseLabel)}">−</button>
                    <span>${item.quantity}</span>
                    <button type="button" data-ct-cart-qty="${item.quantity + 1}" aria-label="${escapeHTML(cartText.qtyIncreaseLabel)}">+</button>
                  </div>

                  <div class="ct-cart-item__price-wrap">
                    <strong class="ct-cart-item__price">${formatMoney(currentLine)}</strong>
                    ${hasLineDiscount ? `<span class="ct-cart-item__compare">${formatMoney(compareLine)}</span>` : ''}
                  </div>
                </div>

                <button type="button" class="ct-cart-item__remove" data-ct-cart-remove>${escapeHTML(cartText.removeText)}</button>
              </div>
            </article>
          `;
        }).join('')}
      </div>
    `;

    const totalSavings = Math.max(0, compareTotal - totalPrice);

    cartSubtotal.textContent = formatMoney(totalPrice);

    if (cartCompareTotal) {
      cartCompareTotal.textContent = totalSavings > 0 ? formatMoney(compareTotal) : '';
      cartCompareTotal.hidden = totalSavings <= 0;
    }

    if (cartCompareRow) {
      cartCompareRow.hidden = totalSavings <= 0;
      cartCompareRow.style.display = totalSavings > 0 ? '' : 'none';
    }

    if (cartSavings) cartSavings.textContent = totalSavings > 0 ? `-${formatMoney(totalSavings)}` : '';

    if (cartSavingsRow) {
      cartSavingsRow.hidden = totalSavings <= 0;
      cartSavingsRow.style.display = totalSavings > 0 ? '' : 'none';
    }

    cartFooter.hidden = false;
  }

  async function fetchCart() {
    if (cartRequestController) cartRequestController.abort();

    const requestController = new AbortController();
    cartRequestController = requestController;

    const timeout = window.setTimeout(() => {
      requestController.abort();
    }, 8000);

    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: requestController.signal
      });

      if (!response.ok) throw new Error('Cart could not be loaded.');

      return await response.json();
    } finally {
      window.clearTimeout(timeout);
      if (cartRequestController === requestController) cartRequestController = null;
    }
  }

  async function refreshCart(options = {}) {
    if (!cartBody) return null;

    const hasRenderedContent = cartBody.querySelector('.ct-cart-drawer__items, .ct-cart-drawer__empty');

    if (options.showLoading && !hasRenderedContent) {
      cartBody.innerHTML = `<div class="ct-cart-drawer__loading">${escapeHTML(cartText.loadingText)}</div>`;
    }

    try {
      const cart = await fetchCart();
      await renderCart(cart);

      window.dispatchEvent(new CustomEvent('ct:cart:updated', {
        bubbles: true,
        detail: { cart }
      }));

      return cart;
    } catch (error) {
      if (error?.name === 'AbortError') return null;

      console.warn('[CT Header] Cart refresh failed:', error);

      if (!hasRenderedContent) {
        cartBody.innerHTML = `<div class="ct-cart-drawer__empty"><div><strong>${escapeHTML(cartText.errorTitle)}</strong><span>${escapeHTML(cartText.errorText)}</span></div></div>`;
        if (cartFooter) cartFooter.hidden = true;
      }

      return null;
    }
  }

  async function updateCartItem(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });

    if (!response.ok) throw new Error('Cart could not be updated.');

    return response.json();
  }

  async function openCart(event) {
    if (!cartDrawer || !cartOverlay) return;

    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    if (menuDrawer.classList.contains('is-open')) closeMenu();

    previousFocus = document.activeElement;

    cartDrawer.classList.add('is-rendering');
    cartDrawer.setAttribute('aria-hidden', 'false');

    cartOverlay.hidden = false;

    requestAnimationFrame(() => {
      cartOverlay.classList.add('is-visible');
      cartDrawer.classList.add('is-open');

      window.setTimeout(() => {
        cartDrawer.classList.remove('is-rendering');
      }, 260);
    });

    lockBody();

    await refreshCart({ showLoading: true });

    requestAnimationFrame(() => {
      const focusable = getFocusableElements(cartDrawer);
      if (focusable.length) focusable[0].focus();
    });
  }

  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;

    cartDrawer.classList.add('is-rendering');
    cartOverlay.classList.remove('is-visible');
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
      if (!cartDrawer.classList.contains('is-open')) {
        cartOverlay.hidden = true;
        cartDrawer.classList.remove('is-rendering');
      }
    }, 360);

    unlockBody();

    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container || !container.classList.contains('is-open')) return;

    const focusable = getFocusableElements(container);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }

    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  menuOpenButton.addEventListener('click', openMenu);
  menuCloseButton.addEventListener('click', closeMenu);
  menuOverlay.addEventListener('click', closeMenu);

  if (cartOpenButton && cartDrawer && cartOverlay) {
    cartOpenButton.addEventListener('click', openCart);
    if (cartCloseButton) cartCloseButton.addEventListener('click', closeCart);
    if (cartContinueButton) cartContinueButton.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);

    cartDrawer.addEventListener('click', async (event) => {
      const item = event.target.closest('[data-ct-cart-item-key]');
      if (!item) return;

      const qtyButton = event.target.closest('[data-ct-cart-qty]');
      const removeButton = event.target.closest('[data-ct-cart-remove]');

      if (!qtyButton && !removeButton) return;

      event.preventDefault();

      const key = item.getAttribute('data-ct-cart-item-key');
      const quantity = removeButton ? 0 : Number(qtyButton.getAttribute('data-ct-cart-qty'));

      try {
        cartBody.classList.add('is-updating');
        const cart = await updateCartItem(key, quantity);
        await renderCart(cart);
      } catch (error) {
        await refreshCart({ showLoading: false });
      } finally {
        cartBody.classList.remove('is-updating');
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (menuDrawer.classList.contains('is-open')) closeMenu();
      if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    }

    trapFocus(event, menuDrawer);
    trapFocus(event, cartDrawer);
  });

  window.CTHeaderCart = {
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    render: (cart) => { renderCart(cart); },
    updateCount: updateHeaderCartCount
  };

  refreshCart({ showLoading: false });
})();
